import { useQuery, UseQueryOptions } from "react-query";
import { HealthCheckResponse, HealthCheckResponseFromJSON } from "../generate";
import { HealthApi } from "../generate/apis/HealthApi";
import { callAnonymous } from "./api";

export const useHealthCheck = (options?: UseQueryOptions<HealthCheckResponse | null | undefined, Error>) => {
  return useQuery<HealthCheckResponse | null | undefined, Error>(
    ["health"],
    async () => {
      try {
        const response = await callAnonymous(HealthApi).healthGet({});
        return response;
      } catch (error) {
        if (error instanceof Response && error.status === 503) {
          const json = await error.json();
          return HealthCheckResponseFromJSON(json);
        }
        throw error;
      }
    },
    options,
  );
};
